import React from 'react';
import PropTypes from 'prop-types';

import ConnectedSearchMap from '../containers/ConnectedSearchMap';
import withStickyScrollNewLayout from './withStickyScrollNewLayout';

export const SearchMapSection = ({
    classes,
    height,
    hoverEventCardTarget,
    onSaveEvent,
    isMobile,
    isFixed,
    setShouldScroll,
    location,
    history,
}) => {
    let component = null;

    if (!location.isOnline) {
        component = (
            <div className={classes}>
                <ConnectedSearchMap
                    height={height}
                    hoverEventCardTarget={hoverEventCardTarget}
                    onSaveEvent={onSaveEvent}
                    isMobile={isMobile}
                    isFixed={isFixed}
                    setShouldScroll={setShouldScroll}
                    history={history}
                />
            </div>
        );
    }

    return component;
};

const SearchMapSectionSticky = withStickyScrollNewLayout(SearchMapSection);

export default class MapPanel extends React.PureComponent {
    static propTypes = {
        onSaveEvent: PropTypes.func,
    };

    render() {
        const {
            onSaveEvent,
            location,
            hoverEventCardTarget,
            shouldLoadGoogleMap,
        } = this.props;

        if (!shouldLoadGoogleMap) {
            return null;
        }

        const searchMapProps = {
            hoverEventCardTarget,
            onSaveEvent,
            location,
        };

        return (
            <div>
                <SearchMapSectionSticky
                    {...searchMapProps}
                    history={this.props.history}
                />
            </div>
        );
    }
}
